var exports = {
  "D": "x127c5a35--9264a8--title",
  "h": "x127c5a35--9264a8--description",
};

module.exports = exports;
